import Pet from '~models/pet'
import { convertPetGender } from '~utils/pet/convert-pet-gender'

const NUMBER_OF_MONTHS = 11
const NUMBER_OF_YEARS = 49
const PET_AGE_NUMBERS = [
  ...Array.from(Array(NUMBER_OF_MONTHS).keys()),
  ...Array.from(Array(NUMBER_OF_YEARS).keys()),
]

export const PET_AGES = PET_AGE_NUMBERS.map((age, index) => {
  const isAgeUnderOneYear = index + 1 <= NUMBER_OF_MONTHS
  const overTwoYearsAge = age + 1
  if (isAgeUnderOneYear) {
    return {
      label: age + 1 === 1 ? `${age + 1} month` : `${age + 1} months`,
      value: age + 1,
    }
  }
  return {
    label: `${overTwoYearsAge} ${overTwoYearsAge === 1 ? 'year' : 'years'} `,
    value: new Date().getFullYear() - overTwoYearsAge,
  }
})

export const getPetAgeFromBornAt = (isoDateString: string) => {
  const birthDate = new Date(isoDateString)
  const currentDate = new Date()

  // Calculate the difference in years and months
  let ageInMonths = (currentDate.getFullYear() - birthDate.getFullYear()) * 12
  ageInMonths += currentDate.getMonth() - birthDate.getMonth()

  // Find the appropriate age object from PET_AGES array
  if (ageInMonths < 12) {
    return PET_AGES[ageInMonths - 1]
  }

  const ageInYears = Math.floor(ageInMonths / 12)
  return PET_AGES[NUMBER_OF_MONTHS + ageInYears - 1]
}

export const GENDERS = Object.values(Pet.Gender) as Pet.Gender[]

export const GENDER_DATA = GENDERS.map(gender => ({
  label: convertPetGender(gender),
  value: gender,
}))

export const NEUTERED_SELECT_LIST = [
  { label: 'Intact', value: false },
  { label: 'Neutered or spayed', value: true },
]
